module.exports = __webpack_public_path__ + "static/img/shoeswoman.4e14bd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cover/20210918/shoeswoman.jpg
// module id = TwAe
// module chunks = 1